<template>
  <v-container>
    <v-layout row v-if='myPatient==null' justify-center class='startbtn'>
      <v-btn color="primary" dark @click.native.stop='openselector'>Click here to select a Patient for Recomm Demo</v-btn>
    </v-layout>
    <v-layout row wrap v-else>
      <v-flex xs12 md4 class='patientpanel' :style='panelStyle'>

        <v-list v-for='(group,key) in myPatientDisplay' :key='key'>
          <v-list-tile>
            <v-list-tile-action>
              <span style="color:green;">{{displaylabel(key)}}</span>
            </v-list-tile-action>
          </v-list-tile>
          <v-layout row wrap>
            <v-flex  v-for='entry in myPatientDisplay[key]'
              :key='entry.name'
              :xs4='displaycol(key)==3'
              :xs6='displaycol(key)==2'
              :xs12='displaycol(key)==1'
            >
              <v-card flat tile v-if='entry.display'>
                <v-card-title v-if='entry.type!="boolean"'>
                  <div class='featurelabel'>{{entry.label}}</div>
                  <div class='featurevalue'><span>{{entry.value}}</span><span v-if='entry.unit' style='flot:right;font-size:70%;'>{{entry.unit}}</span></div>
                </v-card-title>
                <v-card-title v-else>
                <div >
                  <v-icon v-if='entry.value'>check_box</v-icon>
                  <v-icon v-else>check_box_outline_blank</v-icon>
                  <span style='margin-left:0.5rem;'>{{entry.label}}</span>
                </div>
                  <!-- <div class='featurevalue'>{{entry.label}}</div>
                  <div class='featurelabel'><span>{{entry.value}}</span><span v-if='entry.unit' style='flot:right;font-size:70%;'>{{entry.unit}}</span></div> -->
                </v-card-title>
              </v-card>
            </v-flex>
          </v-layout>
          <v-divider></v-divider>
        </v-list>
      </v-flex>

      <v-flex xs12 md7 :style='panelStyle'>
    <v-timeline dense clipped>
      <v-timeline-item
        class="mb-4"
        large
        fill-dot
      >
        <span slot="icon" style='color:#fff;'>Years</span>
        <span class='headline font-weight-light'>USPSTF Recommendations Ranked By Life Expectancy Gained</span>
         <v-progress-linear v-model="comprogress"></v-progress-linear>
      </v-timeline-item>
      <v-slide-x-transition
        group
      >
        <v-timeline-item
          fill-dot
          class="white--text mb-5"
          :key='item.id'
          :class='{active:item.expectancygain<=0}'
          :color='dotcolor(index)'
          v-for='(item,index) in orderedrecs'
        >
          <span slot="icon" v-if='item.expectancygain!=-1'>{{item.expectancygain}}</span>
          <span slot="icon" v-else>  <span class="mdi mdi-loading mdi-spin mdi-18px" v-if='patientready'></span></span>
          <reccard :rec='item' />
        </v-timeline-item>
      </v-slide-x-transition>
    </v-timeline>
          </v-flex>
        </v-layout>
  </v-container>
</template>
<script>

import reccard from '../components/reccard.vue'
  export default {
    data: () => ({
      recs: [],
      events: [],
      input: null,
      nonce: 0,
      reclistko:{"naan":'ipp',"name":'recommendationtable',"ver":'v0.0.2','endpoint':'recommendationlist'},
      reclistready: false,
      lifegainendpoint:'lifeexpectancygained',
      eventlog: [],
      valid: true,
      patientFeaturePanel:{},
      patientready:true,
      reccomputed:0,
      checkbox: false,
      dialog: false,
      patientIndex:-1,
      windowHeight:0
    }),
    created: function(){
      this.$bus.$on('selectPatient', this.selectPatient )
    },
    mounted: function() {
      var self=this
      this.windowHeight = window.innerHeight
      window.addEventListener('resize', () => {
          self.windowHeight = window.innerHeight
        });
      this.recs=[]
      this.patientIndex=this.$store.getters.getCurrentPatientIndex
      // this.$store.commit('setCurrentPatientIndex', this.patientIndex)
    },
    components:{
      reccard
    },
    watch:{
      reclistready:function() {
        var self = this
        if(this.reclistready){
          this.reccomputed =0
          var i=0
          var interval = setInterval(function(){
            self.calculate(i)
            i++;
            self.reccomputed =i
            if(i>=self.recs.length) {
                clearInterval(interval);
              }
          }, 1800);
          // this.processArray(this.recsindex, this.calculate).then(function(results) {
          //   console.log(results)// all done here
          // }, function(reason) {
          //   console.log(reason)// rejection happened
          // });
        }
      },
      myPatient: function(){
        var self =this
        if(this.myPatient!=null){
          var obj ={}
          obj.arkID = this.reclistko.naan+'/'+this.reclistko.name
          obj.endpoint = '/'+this.reclistko.endpoint
          obj.data= JSON.stringify(this.myPatientData)
          obj.key='App'
          obj.success= function(response) {
            console.log(response)
            var outcome = response.result
            for(var key in outcome){
              var rec = outcome[key]
              rec.id=key
              rec.expectancygain=-1
              self.recs.push(rec)
            }
            // self.$store.commit('setFullList',self.recs)
            self.reclistready = true
          }
          obj.error=function(resp){
            console.error(resp)
          }
          this.recs=[]
          this.KOPostaxios(obj)
        }
      }
    },
    computed: {
      // patientIndex: function(){
      //   return this.$store.getters.getCurrentPatientIndex
      // },
      comprogress: function(){
        return this.reccomputed*100/this.recs.length
      },
      panelheight: function(){
        return this.windowHeight - 160
      },
      panelStyle () {
        return {
          height: `${this.panelheight}px`,
        }
      },
      timeline () {
        return this.events.slice().reverse()
      },
      // activator_url:'http://localhost:8080/',
      activator_url: function(){
        // return this.$store.getters.getactivatorurls[0]
        return 'http://localhost:8082/'
      },
      library_url: function(){
        return 'http://localhost:8081/'
        // return this.$store.getters.getlibraryurl
      },
      objlink:function(){
        return this.library_url+'/#/object/'+this.reclistko.naan+'%2F'+this.reclistko.name+'%2F'+this.reclistko.ver
      },
      recsindex:function(){
        return this.recs.map(function(e, index){
          return index
        })
      },
      orderedrecs: function(){
        return this.recs.sort(function(a,b){return b.expectancygain-a.expectancygain})
      },
      myPatient: function(){
        if(this.patientIndex!=-1){
          return this.$store.getters.getPatientPanel(this.patientIndex)
        } else {
          return null
        }
      },
      myPatientData:function(){
        return this.$store.getters.getcurrentPatientData.patient
      },
      myPatientDisplay: function(){
        var groupPanel = {}
        var female = (this.$store.getters.getCurrentPatientDemographics.gender.toLowerCase() == 'female')
        if(this.myPatient!=null){
          this.myPatient.patient.features.forEach(function(e){
            var displayable=true
            if(groupPanel[e.group]==null){
              groupPanel[e.group]=[]
            }
            if(e.flag){
              if(e.flag=='female'){
                displayable=displayable&&female
              }
            }
            e.display=displayable
            groupPanel[e.group].push(e)
          })
        }
        return groupPanel
      },
      groupSchema:function(){
          return this.$store.getters.getGroupDisplaySchema
      }
    },

    methods: {
      selectPatient:function(index){
        console.log(index)
        this.patientIndex=index
        this.reclistready =false
        // this.$store.commit('setCurrentPatientIndex', this.patientIndex)
      },
      openselector: function(){
        this.$bus.$emit('openselector',true)
      },
      processArray: function (array, fn) {
        var index = 0;
        return new Promise(function(resolve, reject) {
          function next() {
            if (index < array.length) {
              setTimeout(()=>fn(array[index++]).then(next, reject), 1500);
            } else {
              resolve();
            }
          }
          next();
        })
      },
      shuffle () {
        this.recs.sort(function(a,b){return b.expectancygain-a.expectancygain})
      },
      dotcolor:function(index){
        var c='#9e9e9e'
        if((this.recs[index].expectancygain>=0)&&(index<1)){
          c='#2196F3'
        }
        return c
      },
      calc:function(index){
        // console.log(index)
        var self = this
        var id = self.recs[index].id
        var obj ={}
        obj.arkID = this.recs[index].benefit.lifegain.ko
        obj.endpoint = '/'+this.lifegainendpoint
        obj.data= '{}'
        obj.delay=100
        obj.key='App'
        obj.success= function(response) {
          console.log(response)
          var outcome = response.result
          self.recs[index].expectancygain=outcome.expectancygained[id]
          self.reccomputed = self.reccomputed +1
        }
        obj.error=function(resp){
          self.recs[index].expectancygain=(Math.floor(Math.random() * Math.floor(10)))/10
          self.reccomputed = self.reccomputed +1
          // self.appendLog('err', "K-GRID Service Response - Simulated data is used for non-existing Knowledge Object: " + instr.arkID);
          console.error(resp)
        }
        if(this.recs[index].benefit.lifegain.ko!=""){
          return this.KOPostaxios(obj)
        } else {
          return Promise.resolve({
            then: function(resolve) {
              self.randomizeexpectancy(index)
            }
          })
        }
      },
      calculate:function(i){
          this.recs[i].expectancygain=(Math.floor(Math.random() * Math.floor(10)))/10;
      },
      displaylabel:function(key){
        if(this.myPatient!=null){
          var inx = this.groupSchema.findIndex(function(e,index){
            return e.groupname==key
          })

          if (inx!=-1){
            return this.groupSchema[inx]['label']
          } else {
            return key
          }
        }
      },
      displaycol:function(key){
        if(this.myPatient!=null){
          var inx = this.groupSchema.findIndex(function(e,index){
            return e.groupname==key
          })
          if (inx!=-1){
            return this.groupSchema[inx]['col']
          } else {
            return 1
          }
        }
      },
      KOPostaxios:function(instr){
        var self = this
        var config = {
          method:'post',
          url:this.activator_url+ instr.arkID + instr.endpoint,
          "headers": {
            "content-type": "application/json",
          },
          "data": instr.data
        }
        self.appendLog(instr.key, "K-GRID Service Request - Sending Patient Data to Knowledge Object: " + instr.arkID);
        return this.$http(config)
          .then(function(response){
            instr.success(response.data)
            self.appendLog(instr.key, "K-GRID Service Response - Response results returned from Knowledge Object: " + instr.arkID);
          })
          .catch(function(error){
            console.error(error)
            self.hasError = true;
            if(error.response.status==404){
              self.error404=true;
            }
            if (error.response) {
              console.log(error.response.data);
              console.log(error.response.status);
              console.log(error.response.headers);
            }
            instr.error(error.response.data);
            // self.appendLog('err', "K-GRID Service Response - Error returned from Knowledge Object: " + instr.arkID);
          })
      },
      appendLog: function (key, s) {
        var ts = this.$moment().format('ddd, MMM Do YYYY, h:mm:ss A Z')
        var text = ts+" "+s
        this.$bus.$emit('newentry', text)
      },
      submit () {
        if (this.$refs.form.validate()) {
          // Native form submission is not yet supported
          // axios.post('/api/submit', {
          //   name: this.name,
          //   email: this.email,
          //   select: this.select,
          //   checkbox: this.checkbox
          // })
        }
      },
      clear () {
        this.$refs.form.reset()
      }
    }
  };
</script>
<style scoped>
.container {
  max-width: 100%;
}
.v-timeline {
  max-width: 86%;
  margin:0 auto;
  padding-top: 24px;
}
.patientpanel{
  background-color: #efefef;
  overflow-y:scroll;
}
.featurelabel {
  font-size: 0.85rem;
  padding: 0 0.2rem ;
  bottom: 0;
  position: relative;
}
.featurevalue {
  font-size: 1.55rem;
  padding: 0 0.2rem 0 0.4rem;;
}
.v-card__title {
  padding: 6px 16px;
}
.v-list {
  padding: 4px 0;
}
.startbtn {
  position: absolute;
  bottom: 380px;
  width: 100%;
}
</style>
